import { render, staticRenderFns } from "./stages-input.vue?vue&type=template&id=40a9c244&scoped=true"
import script from "./stages-input.vue?vue&type=script&lang=js"
export * from "./stages-input.vue?vue&type=script&lang=js"
import style0 from "./stages-input.vue?vue&type=style&index=0&id=40a9c244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9c244",
  null
  
)

export default component.exports